export default __webpack_public_path__ + "static/media/bg-small.eb6ed0c8.png";